import axios, { AxiosResponse } from "axios";

import { client } from "src/api/rest/client";
import {
    MarketplaceApiFailure,
    MarketplaceBootstrap,
    MarketplaceProvisionBrandLocationResult,
} from "./types";

export class MarketplaceApiError extends Error {
    constructor(
        readonly code: string,
        message: string,
        readonly status?: number,
    ) {
        super(message);
    }
}

async function request<T>(apiRequest: Promise<AxiosResponse<T>>): Promise<T> {
    try {
        const response = await apiRequest;
        return response.data;
    } catch (error) {
        if (axios.isAxiosError<MarketplaceApiFailure>(error)) {
            const failure = error.response?.data;
            if (
                failure?.success === false &&
                typeof failure.code === "string" &&
                typeof failure.error === "string"
            ) {
                throw new MarketplaceApiError(
                    failure.code,
                    failure.error,
                    error.response?.status,
                );
            }
        }
        throw error;
    }
}

export const getMarketplaceBootstrap = async () =>
    request(client.get<MarketplaceBootstrap>("/marketplace/bootstrap"));

export const provisionMarketplaceBrandLocation = async (locationId: string) =>
    request(
        client.post<MarketplaceProvisionBrandLocationResult>(
            `/marketplace/brand-locations/${encodeURIComponent(locationId)}/provision`,
        ),
    );
